import $ from 'jquery';
/**
 * Enables the "back to top" functionality.
 */
const enableBackToTopFunctionality = () => {
    // enable "back to top" functionality
    $('#back-to-top').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 800);
    });
};
export default enableBackToTopFunctionality;
